import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-statement-page',
  templateUrl: './privacy-statement-page.component.html',
  styleUrls: ['./privacy-statement-page.component.scss']
})
export class PrivacyStatementPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
